import { FaExclamationTriangle } from "react-icons/fa";

import EyeIcon from "../../components/EyeIcon";
import TableSearch from "../../components/TableSearch";
import PaginationControls from "../../components/Pagination";

import { dateConverter, numberToCurrency } from "../../helpers/functions";

const List = ({
  data,
  page,
  limit,
  count,
  searchValue,
  onView = () => {},
  onSearch = () => {},
  onPageChange = () => {},
}) => {
  return (
    <>
      <div className="card d-none d-md-block w-100">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span className="d-flex align-items-center">
            <FaExclamationTriangle className="me-2" /> Due Payments
          </span>
        </div>
        <div className="card-body">
          <TableSearch value={searchValue} onChange={onSearch} />
          <div className="table-responsive ">
            <table className="table table-bordered border-light" id="payments">
              <thead className="table-light">
                <tr>
                  <th className="border-end">#</th>
                  <th className="border-end">Date</th>
                  <th className="border-end">Customer</th>
                  <th className="border-end">Boat</th>
                  <th className="border-end">Total Amount</th>
                  <th className="border-end">Due Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="border-end text-center text-nowrap">
                      {(page - 1) * limit + index + 1}
                    </td>
                    <td className="border-end text-center text-nowrap">
                      {dateConverter(item.date) || ""}
                    </td>
                    <td className="border-end">{item.name || ""}</td>
                    <td className="border-end">{item.boat}</td>
                    <td className="border-end text-end text-nowrap">
                      {numberToCurrency(item.amount)}
                    </td>
                    <td
                      className={`border-end text-end text-nowrap ${
                        item.dueAmount > 0 ? "text-danger " : "text-success "
                      }`}
                    >
                      {numberToCurrency(item.dueAmount)}
                    </td>
                    <td>
                      <div className="d-flex gap-2 justify-content-center">
                        <EyeIcon onClick={() => onView({ show: true, id: item._id })} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <PaginationControls page={page} count={count} limit={limit} onChange={onPageChange} />
        </div>
      </div>
      <div className="d-md-none mb-4 w-100">
        {data.map((item) => (
          <div key={item.id} className="card shadow-sm mb-3">
            <div className="card-body">
              <div className="row g-2 mb-3">
                <div className="col-6">
                  <small className="text-muted">Date</small>
                  <p className="mb-0 fw-medium">{dateConverter(item.date)}</p>
                </div>
                <div className="col-6">
                  <small className="text-muted">Customer</small>
                  <p className="mb-0 fw-medium">{item.name || ""}</p>
                </div>
                <div className="col-6">
                  <small className="text-muted">Boat Name</small>
                  <p className="mb-0 fw-medium">{item.boat || ""}</p>
                </div>
                <div className="col-6">
                  <small className="text-muted">Total Amount</small>
                  <p className="mb-0 fw-bold">{numberToCurrency(item.amount)}</p>
                </div>
              </div>

              <div className="row align-items-center g-2">
                <div className="col">
                  <small className="text-muted">Due Amount</small>
                  <p className={`mb-0 ${item.dueAmount > 0 ? "text-danger" : "text-success"}`}>
                    {numberToCurrency(item.dueAmount)}
                  </p>
                </div>
                <div className="col-auto">
                  <span className="badge bg-light text-dark">
                    {item.dueAmount > 0 ? "Pending" : "Paid"}
                  </span>
                </div>
              </div>

              <hr className="my-2" />

              <div className="mb-2">
                <small className="text-muted">Description</small>
                <p className="mb-0 text-truncate" title={item.remarks}>
                  {item.remarks}
                </p>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <EyeIcon size="sm" onClick={() => onView({ show: true, id: item._id })} />
              </div>
            </div>
          </div>
        ))}

        <div className="mb-3">
          <PaginationControls page={page} count={count} limit={limit} onChange={onPageChange} />
        </div>
      </div>
    </>
  );
};

export default List;
